/**
 * Oudh Al Anfar — scent profile
 * ---------------------------------------------------------------------------
 * <oaa-scent-profile> fills the three bands once the component enters the
 * viewport: 700ms per band, 120ms apart, top → heart → base.
 *
 * The bars are decoration. They carry `aria-hidden`, and the note pills below
 * them carry the meaning, so nothing here is load-bearing for a screen reader.
 * Under `prefers-reduced-motion` the CSS renders the bands pre-filled and this
 * module does nothing at all beyond setting the flag.
 * ---------------------------------------------------------------------------
 */

class OaaScentProfile extends HTMLElement {
  connectedCallback() {
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (reduced || !('IntersectionObserver' in window)) {
      this.dataset.filled = 'true';
      return;
    }

    this.#observer = new IntersectionObserver(
      ([entry]) => {
        if (!entry.isIntersecting) return;
        this.dataset.filled = 'true';
        this.#observer?.disconnect();
      },
      { threshold: 0.25 }
    );

    this.#observer.observe(this);
  }

  disconnectedCallback() {
    this.#observer?.disconnect();
  }

  #observer;
}

if (!customElements.get('oaa-scent-profile')) {
  customElements.define('oaa-scent-profile', OaaScentProfile);
}
